import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from '@/components/site/SiteHeader';
import { SiteFooter } from '@/components/site/SiteFooter';
import { CartSheet } from '@/components/site/CartSheet';

/** Ramme for den offentlige nettsiden. Forsiden har gjennomsiktig toppfelt over hero-bildet. */
export default function SiteLayout() {
  const location = useLocation();
  const isLanding = location.pathname === '/';

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return (
    <div className="site flex min-h-screen flex-col bg-white text-[var(--hr-text)]">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[400] focus:rounded-md focus:bg-white focus:px-3 focus:py-2 focus:text-sm focus:shadow-[var(--hr-shadow-md)]">
        Hopp til hovedinnholdet
      </a>
      <SiteHeader transparent={isLanding} />
      <main id="main" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />
      <CartSheet />
    </div>
  );
}
